export default __webpack_public_path__ + "static/media/fund-size-icon.d238312b.svg";